import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { PLANT_STATUS, SOURCE_TYPES, GROWTH_STAGES, HEALTH_STATUS } from "../lib/theme";

export const detailsFrom = (p = {}) => ({
  cultivar: p.cultivar || "", status: p.status || "active", growth_stage: p.growth_stage || "", health_status: p.health_status || "",
  source_type: p.source_type || "", source_detail: p.source_detail || "",
  value: p.value ?? "", purchase_price: p.purchase_price ?? "", birth_date: p.birth_date ? p.birth_date.slice(0, 10) : "",
  pot_size: p.pot_size || "", pot_material: p.pot_material || "", soil_mix: p.soil_mix || "", tags: (p.tags || []).join(", "), light_exposure: p.light_exposure || "",
});

export const detailsPayload = (d) => ({
  ...d,
  value: d.value === "" ? null : Number(d.value),
  purchase_price: d.purchase_price === "" ? null : Number(d.purchase_price),
  source_type: d.source_type || null,
  growth_stage: d.growth_stage || null,
  health_status: d.health_status || null,
  light_exposure: d.light_exposure || null,
  tags: d.tags.split(",").map((t) => t.trim()).filter(Boolean),
});

function F({ label, children }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

function Pick({ value, onChange, options, testid, placeholder }) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="rounded-xl h-10"><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {Object.entries(options).map(([k, v]) => <SelectItem key={k} value={k}>{typeof v === "string" ? v : v.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export default function PlantDetailsFields({ value: d, onChange }) {
  const set = (k) => (v) => onChange({ ...d, [k]: v?.target ? v.target.value : v });
  const inp = (k, props = {}) => <Input data-testid={`detail-${k}-input`} value={d[k]} onChange={set(k)} className="rounded-xl h-10" {...props} />;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="plant-details-fields">
      <F label="Status"><Pick value={d.status} onChange={set("status")} options={PLANT_STATUS} testid="detail-status-select" /></F>
      <F label="Overall health"><Pick value={d.health_status} onChange={set("health_status")} options={HEALTH_STATUS} testid="detail-health-select" placeholder="Choose" /></F>
      <F label="Growth stage"><Pick value={d.growth_stage} onChange={set("growth_stage")} options={GROWTH_STAGES} testid="detail-stage-select" placeholder="Choose" /></F>
      <F label="Cultivar / variety">{inp("cultivar", { placeholder: "Thai Constellation" })}</F>
      <F label="Came from"><Pick value={d.source_type} onChange={set("source_type")} options={SOURCE_TYPES} testid="detail-source-select" placeholder="Choose source" /></F>
      <F label="Source detail">{inp("source_detail", { placeholder: "Seller, friend, shop..." })}</F>
      <F label="Birth / est. start date">{inp("birth_date", { type: "date" })}</F>
      <F label="Current value (USD)">{inp("value", { type: "number", min: 0, step: "1", placeholder: "0" })}</F>
      <F label="Purchase price (USD)">{inp("purchase_price", { type: "number", min: 0, step: "1", placeholder: "0" })}</F>
      <F label="Pot size">{inp("pot_size", { placeholder: '6" nursery pot' })}</F>
      <F label="Pot material">{inp("pot_material", { placeholder: "Terracotta" })}</F>
      <F label="Soil mix">{inp("soil_mix", { placeholder: "Aroid mix, 30% perlite" })}</F>
      <F label="Tags (comma separated)">{inp("tags", { placeholder: "rare, variegated" })}</F>
    </div>
  );
}
